export const formatPercentage = (input: number) => {
    return new Intl.NumberFormat('default', {
        style: 'percent',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format((input / 100) * 100);
};
